/**
 * Format an utterance's capture time as a wall-clock time of day shown beside
 * each transcript line (#10002), e.g. "2:35 PM". Accepts an ISO string or epoch
 * ms. Returns "" for missing/invalid timing so callers can skip rendering.
 *
 * `timeZone` is mainly for deterministic tests; in the app it defaults to the
 * viewer's local zone.
 */
export function formatTranscriptTimestamp(
  capturedAt: string | number | null,
  timeZone?: string
): string {
  if (capturedAt === null || capturedAt === "" || capturedAt === 0) return "";
  const date = new Date(capturedAt);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone,
  });
}
